var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftbottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 242,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 194.89V15C1 2.614 16.237-3.29 24.583 5.862L218.3 218.3c7.939 8.707 1.762 22.7-10.021 22.7H47.11C21.644 241 1 220.356 1 194.89Z",
    fill: "#D8E3FF",
    stroke: "#3B37E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftbottom);
export default __webpack_public_path__ + "static/media/leftbottom.fbcd8aa792416e2b047f88a968dccafd.svg";
export { ForwardRef as ReactComponent };